import { dayNameOfIsoDate, toIsoDate } from '../../utils/dateUtils';

const itemKey = (date, periodId, groupId) => `${date}|${periodId}|${groupId}`;

/**
 * A semester kept by date, shaped the way CalendarSchedule reads a schedule. Shared by the table
 * and the xlsx export, so both see the same lessons on the same dates.
 *
 * <p>CalendarSchedule looks a day up by its weekday, so the periods are offered under every
 * weekday the semester runs on. Which of them actually hold something is decided by cardsFor,
 * which matches the server's items to the date directly instead of going through week parity.
 *
 * @returns { fullSchedule: { semester, groupList, resultArray }, cardsFor }
 */
export const byDateCalendar = (byDate) => {
    const { semester, dates = [], periods = [], groups = [], items = [] } = byDate ?? {};

    const weekdays = [...new Set(dates.map(dayNameOfIsoDate))];
    const resultArray = weekdays.map((day) => ({
        day,
        classes: periods.map((period) => ({ class: period, cards: { odd: [], even: [] } })),
    }));

    // Indexed once rather than scanned per cell: cardsFor runs for every date, period and group,
    // several times over, so a linear find here would make the work quadratic in the items.
    const lessonByKey = new Map(
        items.map((item) => [itemKey(item.date, item.period.id, item.group.id), item.lesson]),
    );

    const cardsFor = (calendarDay, classItem) => {
        const date = toIsoDate(calendarDay.date);
        return groups.map((group) => ({
            group,
            card: lessonByKey.get(itemKey(date, classItem.class.id, group.id)) ?? null,
        }));
    };

    return { fullSchedule: { semester, groupList: groups, resultArray }, cardsFor };
};